import { Settings } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EmptyState } from 'src/shared/components/atoms/emptyState';
import { PermissionEnum } from 'src/shared/models/enums/permissionEnums';
import { ContentSection } from 'src/shared/components/organisms/contentSection';
import { getPermission } from 'src/shared/functions/getSysProductPermissions';
import { useGlobals } from 'src/shared/contexts/appContext';
import { InvoiceAddressHandleModal } from '../invoicerecipient/components/invoiceAddressHandleModal';
import { Member } from '../models/member';

type MemberInvoiceAddressProps = {
  member: Member;
};

const MemberInvoiceAddress = (props: MemberInvoiceAddressProps) => {
  const { member } = props;
  const { t } = useTranslation();
  const { currentUser } = useGlobals();

  const [handleInvoiceAddress, setHandleInvoiceAddress] = useState(false);

  // Fakturamottagare aktiverat = enableAddInvoiceAddress true på medlem
  // Fakturaadress finns & fakturamottagare aktiverat - Visa contentsection
  // Fakturaadress finns inte & fakturamottagare aktiverat - Visa contentsection
  // Fakturaadress finns & fakturamottagare INTE aktiverat - Visa contentsection men dölj knapp för hantera
  // Fakturaadress finns inte & fakturamottagare INTE aktiverat - Visa INTE contentsection
  const invoiceAddressEnabled = member.enableAddInvoiceAddress;
  const memberHasInvoiceAddress = member.invoiceAddress;
  const hasPermissionToEdit = getPermission(currentUser, `${PermissionEnum.InvoiceAddressUpdate}`);
  const hasMemberUpdatePermission = getPermission(currentUser, PermissionEnum.MemberUpdate);

  if (!invoiceAddressEnabled && !memberHasInvoiceAddress) return null;

  return (
    <>
      <ContentSection
        header={t('member:invoiceAddress.pageHeader')}
        button={
          hasPermissionToEdit && invoiceAddressEnabled ? (
            <Button
              disabled={!hasMemberUpdatePermission}
              size='small'
              variant='outlined'
              endIcon={<Settings fontSize='small' />}
              onClick={() => {
                setHandleInvoiceAddress(true);
              }}
            >
              {t('common:button.handle')}
            </Button>
          ) : undefined
        }
      >
        {!member.invoiceAddress && <EmptyState text={t('member:invoiceAddress.noInvoiceAddress')} />}
        {/* Rutnätet renderas bara när det finns en adress. Ett tomt rutnät tar plats och
            gav ett större avstånd här än i övriga avsnitt. */}
        {member.invoiceAddress && (
          <Grid container>
            <Grid item xs={12} sm={4} mb={{ xs: 2, sm: 0 }}>
              {member.invoiceAddress?.name && <Typography variant='body1'>{member.invoiceAddress.name}</Typography>}
              {member.invoiceAddress?.address && <Typography variant='body1'>{member.invoiceAddress.address}</Typography>}
              {member.invoiceAddress?.postalcode && member.invoiceAddress?.city && (
                <Typography variant='body1'>{`${member.invoiceAddress.postalcode} ${member.invoiceAddress.city}`}</Typography>
              )}
            </Grid>
            {member.invoiceAddress?.email && (
              <Grid item xs={12} sm={4} mb={{ xs: 2, sm: 0 }}>
                <Typography variant='body1' fontWeight={600}>
                  {t('member:invoiceAddress.email')}:
                </Typography>
                <Typography variant='body1'>{member.invoiceAddress.email}</Typography>
              </Grid>
            )}
            {member.invoiceReference && (
              <Grid item xs={12} sm={4} mb={{ xs: 1, sm: 0 }}>
                <Typography variant='body1' fontWeight={600}>
                  {t('member:invoiceAddress.reference')}:
                </Typography>
                <Typography variant='body1'>{member.invoiceReference}</Typography>
              </Grid>
            )}
          </Grid>
        )}
      </ContentSection>
      {member && handleInvoiceAddress && (
        <InvoiceAddressHandleModal
          modalOpen={handleInvoiceAddress}
          onClose={() => setHandleInvoiceAddress(false)}
          onSave={() => setHandleInvoiceAddress(false)}
          member={member}
        />
      )}
    </>
  );
};

export default MemberInvoiceAddress;
